import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MessageService, Message, ConfirmationService } from 'primeng/api';
import { EfileService } from 'src/app/services/efile.service';
import { CaseService } from 'src/app/services/case.service';
import { DictionaryService } from 'src/app/services/dictionary.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { DatePipe, formatCurrency } from '@angular/common';

import { EFileApplicationDto } from 'src/app/application/efile/dto/efile-app.dto';
import { EFilePaymentDto } from 'src/app/application/efile/dto/efile-payment.dto';
import { ThrowStmt } from '@angular/compiler';


@Component({
    selector: 'efiling-details',
    templateUrl: './efiling-details.component.html',
})

export class EfileDetailsComponent implements OnInit {
    @Input() efileId: string;
    @Output() changeEvent = new EventEmitter();

    numAccordionTabs = 9;
    // accordionOpenIndex = [0, 1, 2, 3, 4, 5, 6, 7];
    accordionOpenIndex = [];

    myYear: number;
    myApplication: any;
    myApplicant: any;
    myAgency: any;
    myProperty: any;
    myRollValues: any;
    myOpinionValues: any;
    myAssessment: any;
    myFacts: any;
    myCertification: any;
    myPayment: any;
    myEFileDocs: any[];
    //
    typeOfAttachement: any[];
    paymentList: EFilePaymentDto[]; // will contain ALL payment transactions collected by EFiling
    efiledData: any;
    cols: any[];
    payCols: any[];
    //
    dictionaryList: any;
    statusList: [];
    subStatusList: [];
    cityList: string[];
    payStatusList: any[];   // payment statuses (from EFiling)

    displayState: any = {
        indexDiv: false,
        workingDiv: false,
        detailsDiv: false,
    };

    filterOptions: any = {
        filterText: '',
    };

    constructor(private messageService: MessageService, private efileService: EfileService, private caseService: CaseService,
        private dictService: DictionaryService, private confirmationService: ConfirmationService, private datePipe: DatePipe,
        private utilService: UtilitiesService) { }

    ngOnInit() {
        this.efiledData = null;

        this.cols = [
            { field: 'typeOfAttachmentId', header: 'Document Type' },
            { field: 'description', header: 'Description' },
        ];
        this.payCols = [
            { field: 'paymentDate', header: 'Paid on' },
            { field: 'appliedAmount', header: 'Amount' },
            { field: 'username', header: 'User' },
            { field: 'transactionId', header: 'Trans Id'},
        ]

        // get Dictionaries
        this.dictionaryList = this.dictService.getDictionaries();
        this.typeOfAttachement = this.dictionaryList.documentTypes;
        this.myEFileDocs = [];  // initialize array so it is defined and does not generate an error in the template

        this.statusList = this.dictionaryList.statusChoices;
        this.subStatusList = this.dictionaryList.subStatusChoices;
        this.cityList = this.dictionaryList.cityChoices;
        this.payStatusList = this.dictionaryList.paymentStatusTypes;
        //this.utilService.doAudit(this.dictionaryList);

        // finally, get application data
        this.getEfiledApplication();
    }

    exitDetails() {
        this.utilService.doAudit('Exiting details');
        this.changeEvent.emit('exiting details'); //
      }


    getEfiledApplication() {
        this.utilService.doAudit('getting application; efileId: ' + this.efileId);
        this.efileService.getEfiledApplication(this.efileId).subscribe(data => {
            this.utilService.doAudit(data, 'efile application id: ' + this.efileId);
            this.efiledData = data;
            this.myApplicant = data.applicationApplicantDto ? data.applicationApplicantDto : {};
            if (this.myApplicant) {
                this.myApplicant.fullName = this.myApplicant.lastName + ( this.myApplicant.firstName? ', ' + this.myApplicant.firstName: '');
            }
            if (data.applicationAgentDto) {
                this.myAgency = data.applicationAgentDto;
            } else {
                this.myAgency = {}
            }
            this.myProperty = data.applicationPropertyDto ? data.applicationPropertyDto: {};
            this.myRollValues = data.applicationRollValueDto ? data.applicationRollValueDto : {};
            this.myOpinionValues = data.applicationOpinionValueDto ? data.applicationOpinionValueDto : {};
            this.myAssessment = data.applicationAssessmentDto ? data.applicationAssessmentDto: {};
            this.myFacts = data.applicationFactDto ? data.applicationFactDto : {};
            this.myCertification = data.applicationCertificationDto ? data.applicationCertificationDto : {};
            //
            this.myApplication = {};
            this.myApplication.caseNumber = data.applicationNumber;
            this.myApplication.userName = data.username;
            this.myApplication.hasEnteredTotals = data.hasEnteredTotals;
            this.myApplication.areFindingsRequested = data.areFindingsRequested;
            this.myApplication.isClaimForRefund = data.isClaimForRefund;
            let claimRefund = data.isClaimForRefund;
            if (claimRefund === true) {
              claimRefund = 'Yes';
            } else {
              claimRefund = 'No';
            }
            this.utilService.doAudit('claim refund: ' + claimRefund);

            // NOTE:   ReceivedDate is CORRECT, i.e. handles Time Zone; SEE CASES 2020-001 - 2020-003
            this.getEFiledDocs();   // get documents/files attached to application during E-Filing process...
            this.getEFilePaymentInfo(); // get application payment info...
            //this.displayState.workingDiv = false;
            //this.displayState.detailsDiv = true;
        });
    }

    getEFiledDocs() {
        this.myEFileDocs = [];
        this.efileService.getEFileDocs(this.efileId.toString()).subscribe(data => {
            this.utilService.doAudit(data, 'efiled documents:');
            for (let doc of data) {
                doc.typeOfDocument = this.typeOfAttachement.filter(t => t.id == doc.typeOfAttachmentId)
                this.myEFileDocs.push(doc);
            };
            this.displayState.workingDiv = false;
            this.displayState.detailsDiv = true;
        });
    }

    getEFilePaymentInfo() {
        this.efileService.getPaymentInfo(this.efileId).subscribe(payments => {
            const compTrans = payments.filter(pay => {
                return pay.statusId === 3 ? pay : null; // only pick up transactions with "Completed" status
            });
            if (compTrans) {
                this.paymentList = compTrans;
                // this.myCase.comment = this.myCase.comment + '\nPayment of $' + payRec.appliedAmount + ' was submitted by: ' + payRec.username + ', on: ' + payDate + '.';
            }
        });
    }

    showAddFields() {
        if (this.myAssessment.typeOfAssessmentId > 1) {
            return true;
        } else { return false; }
    }

    openAllSections() {
        this.accordionOpenIndex = [];
        for (let i = 0; i < this.numAccordionTabs; i++ ) {
          this.accordionOpenIndex.push(i);
        }
      }

      closeAllSections() {
        this.accordionOpenIndex = [];
      }

    rejectApp(row:any) {
        var appId = row.applicationId;
    };

    // view document uploaded to EFile system
    viewEfileDoc(myUrl: string) {
        //console.log(myUrl);
        window.open(myUrl, '_blank');
    }

    getTodaysDate() {
        let today = new Date();
        let dd = today.getDate();
        let mm = today.getMonth() + 1; //January is 0!
        let yyyy = today.getFullYear();
        let tDay = '', tMonth = '', tToday = '';
        if (dd < 10) {
            tDay = '0' + dd;
        }
        if (mm < 10) {
            tMonth = '0' + mm;
        }
        tToday = mm + '/' + dd + '/' + yyyy;
        return tToday;
    }

    getTodaysYear() {
        let yyy = new Date().getFullYear;
        return yyy;
    }

    stripDashes(x) {
        if (x === null || x === undefined) {
            return '';
        }
        return x.toString().replace(/-/g, "");
    }

    // validation methods
    validateApp() {
        let appIdList = [];
        appIdList.push(this.efileId);
        this.utilService.doAudit(appIdList,'validating app:');
        this.efileService.validateApps(appIdList).subscribe(d => {
            this.utilService.doAudit(d,'result from validateApp');
            if (d != null) {
                this.handleValidationResults(d, appIdList);
                return;
            } else {
                alert('Error: Unable to validate application');
                return;
            }
        });
    }

    handleValidationResults(data:any, appIdList: any) {
        if (data != null) {
            var retVal = {
                allValid: false,
                errCount: 0,
                paymentAmt: 0.0,
                errMsg: '',
                appList: []
            };
            var appId = 0, isValid = false, chgAmt = 0.0, errText = '', propDesc = '';
            for (var i = 0; i < data.length; i++) {
                appId = data[i].applicationId;
                isValid = data[i].isValid;
                console.log(i + ' object; isValid: ' + isValid + '; # error lines: ' + data[i].errorDescription.length);
                //isValid = true; // FOR TESTING ONLY!!
                if (isValid == false) {
                    retVal.errCount++;
                    propDesc = 'Unknown property';
                    if (data[i].propertyParcelNumber) {
                        propDesc = 'Parcel #: ' + data[i].propertyParcelNumber;
                    }
                    else if (data[i].assessmentNumber) {
                        propDesc = 'Assessment #: ' + data[i].assessmentNumber;
                    }
                    else if (data[i].propertyAddress) {
                        propDesc = 'Property Address: ' + data[i].propertyAddress;
                    }
                    else if (data[i].propertyDescription) {
                        propDesc = 'Property: ' + data[i].propertyDescription;
                    }
                    else if (data[i].applicantName) {
                        propDesc = 'Applicant: ' + data[i].applicantName;
                    }
                    if (data[i].errorDescription.length > 0) {
                        if (retVal.errCount > 1) {
                            errText = errText + '\n';
                        }
                        errText = errText + 'For ' + propDesc + '\n'; // + ' (id: ' + appId + ')' + '\n';
                        for (var j = 0; j < data[i].errorDescription.length; j++) {
                            errText = errText + ' ' + data[i].errorDescription[j] + '\n';
                            console.log('line' + j + '; ' + data[i].errorDescription[j]);
                        }
                    }
                }
                else {
                    chgAmt = chgAmt + data[i].paymentAmount;
                }
            }
            retVal.paymentAmt = chgAmt;
            //
            retVal.appList = data;   //pass back the details so we can get the amount charged for each item
            //
            if (retVal.errCount > 0) {
                retVal.allValid = false;
                retVal.errMsg = 'There is missing data!:\n\n' + errText;
            }
            else { retVal.allValid = true }
            this.utilService.doAudit(retVal,'validation results');
            if (retVal.allValid == false) {
                //this.showToast({ key: 'info', severity: 'warning', detail: retVal.errMsg, summary: 'Info' });
                alert(retVal.errMsg);
            }
            if (retVal.allValid == true) {
                alert('Application is valid');
            }
            return;
        }
    }

    // Mapping Methods

    // Toaster-related methods
    showToast(msg: Message) {
        this.messageService.add(msg);
      }

    showConfirm() {
        this.messageService.clear();
        this.messageService.add({key: 'c', sticky: true, severity: 'warn', summary: 'Are you sure?', detail: 'Confirm to proceed'});
    }

    onConfirm() {
        this.messageService.clear('c');
    }

    onReject() {
        this.messageService.clear('c');
    }

    clear() {
        this.messageService.clear();
    }

}
